import { FormEvent, useEffect, useState } from 'react';
import { DraggableModalPanel } from '../ui/DraggableModalPanel';

type TableInsertModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (rows: number, cols: number) => void;
};

function parsePositiveInt(raw: string, fallback: number): number {
  const parsed = Number.parseInt(raw, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
}

export function TableInsertModal({ open, onClose, onConfirm }: TableInsertModalProps) {
  const [rows, setRows] = useState('3');
  const [cols, setCols] = useState('3');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!open) return;
    setRows('3');
    setCols('3');
    setError(null);
  }, [open]);

  function handleSubmit(event: FormEvent): void {
    event.preventDefault();
    const rowCount = parsePositiveInt(rows, 0);
    const colCount = parsePositiveInt(cols, 0);
    if (rowCount < 1 || colCount < 1) {
      setError('Informe pelo menos 1 linha e 1 coluna.');
      return;
    }
    if (rowCount > 20 || colCount > 10) {
      setError('Máximo: 20 linhas e 10 colunas.');
      return;
    }
    onConfirm(rowCount, colCount);
    onClose();
  }

  return (
    <DraggableModalPanel
      open={open}
      title="Inserir tabela"
      subtitle="Defina o tamanho inicial da tabela."
      onClose={onClose}
      className="w-full max-w-sm"
      footer={
        <div className="flex flex-wrap justify-end gap-2">
          <button type="button" className="erp-btn-secondary" onClick={onClose}>
            Cancelar
          </button>
          <button type="submit" form="rte-table-insert-form" className="erp-btn-primary">
            Inserir
          </button>
        </div>
      }
    >
      <form id="rte-table-insert-form" className="grid grid-cols-2 gap-3" onSubmit={handleSubmit}>
        <label className="erp-label-block">
          Linhas
          <input
            className="erp-input"
            type="number"
            min={1}
            max={20}
            value={rows}
            onChange={(e) => {
              setRows(e.target.value);
              setError(null);
            }}
            onMouseDown={(e) => e.stopPropagation()}
            autoFocus
          />
        </label>
        <label className="erp-label-block">
          Colunas
          <input
            className="erp-input"
            type="number"
            min={1}
            max={10}
            value={cols}
            onChange={(e) => {
              setCols(e.target.value);
              setError(null);
            }}
            onMouseDown={(e) => e.stopPropagation()}
          />
        </label>
        {error ? <p className="col-span-2 text-sm text-red-600">{error}</p> : null}
      </form>
    </DraggableModalPanel>
  );
}
